import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from "@angular/core";
import {FormGroup} from "@angular/forms";
import {NgSelectComponent} from "@ng-select/ng-select";

@Component({
    selector: 'date-picker',
    templateUrl: './date-picker.template.html',
    styleUrls: ['./date-picker.style.scss'],
    standalone: false
})
export class DatePickerComponent implements OnInit {

	readonly days: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
	years: number[] = [];

	@Input() controlName: string;
	@Input() formGroup: FormGroup;
	@Input() value;
	@Input() id: string;
	@Input() invalidDate: boolean = false;

	@Output() onDateChangeInDefault: EventEmitter<Date> = new EventEmitter<Date>();

	@ViewChild('monthSelector', {static: false}) monthSelect: NgSelectComponent;
	@ViewChild('daySelector', {static: false}) daySelect: NgSelectComponent;
	@ViewChild('yearSelector', {static: false}) yearSelect: NgSelectComponent;

	selectedMonth: number;
	selectedDay: number;
	selectedYear: number;

	constructor() {
		this.initializeYearsList();
	}

	ngOnInit(): void {
		if (this.value != null) {
			this.selectedMonth = Number((this.value as string).split("-")[1]);
			this.selectedDay = Number((this.value as string).split("-")[2]);
			this.selectedYear = Number((this.value as string).split("-")[0]);
		}
	}

	private initializeYearsList() {
		const currentYear: number = new Date().getFullYear();
		this.years.push(currentYear);
		for (let i: number = 1; i < 20; i += 1) {
			this.years.push(currentYear + i);
			this.years.push(currentYear - i);
		}
		this.years.sort((a, b) => a > b ? 1 : -1);
	}

	keyPressed(event) {
		if (event.code === 'Delete') {
			this.triggerOnDateChangeInDefault(null);
		}
	}

	triggerOnDateChangeInDefault(value: Date) {
		this.onDateChangeInDefault.emit(value);
	}

}
